module.exports = {"report":{"stations":"สถานี","headers":"หัวข้อ"}}


//////////////////
// WEBPACK FOOTER
// ./src/wording/language/th/report.json
// module id = 119
// module chunks = 35